<template>
    <div>
        <div class="cb_thanks" v-if="type=='purchase'">
            <div>{{ characters.subscription_purchase_end }}</div>
            <div>{{ characters.thank_to_purchase }}</div>
        </div>
        <div class="cb_thanks" v-if="type=='regist'">
            <div>{{ characters.thank_to_regist }}</div>
        </div>
        <div v-if="pay_kind === 'credit' && type!='regist'" class="cb_thanks">
            <form :id="pay_kind" target="_top">
                <input type="hidden" name="_token" :value="csrf_token">
            </form>
            <div id="jump-store" class="confirm"><button type="submit" @click="regist">{{ characters.regist_card_info }}</button></div>
        </div>
        <div class="confirm">
            <button type="submit" @click="jumpSubscriptionStatus()">{{ characters.open_subscription_confirm_page }}</button>
        </div>
        <div class="confirm">
            <button type="submit" @click="jumpSubscriptionPurchaseHistory()">{{ characters.open_subscription_history_page }}</button>
        </div>
    </div>

</template>

<script>
    export default {
        name: "subscription-purchase-end",
        props: ['csrf_token', 'pay_kind', 'order_site', 'credit_reg_flag', 'type', 'json_characters'],
        data: function () {
            return {
                characters: Object,
            }
        },
        mounted() {
            // if(this.pay_kind == 'credit' && this.credit_reg_flag != 1) {
            //     this.regist();
            // }
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            regist: function() {
                let form = document.forms[this.pay_kind];
                form.action = this.order_site+'/regist_'+this.pay_kind+'.php';
                // form.action = this.order_site+'/confirm_'+this.pay_kind+'.php';
                form.method = 'POST';
                axios.default
                    .post('/purchase/regist', {pay_kind: this.pay_kind})
                    .then(response => {
                        for(const key in response.data) {
                            form.innerHTML+='<input type="hidden" name="'+key+'" value="'+response.data[key]+'">';
                        }
                        form.submit();
                    });
            },
            jumpSubscriptionPurchaseHistory: function() {
                location.href="/subscription/purchase/history";
            },
            jumpSubscriptionStatus: function() {
                location.href="/subscription/confirm";
            },
        }
    }
</script>

<style scoped>
</style>
